import { render, staticRenderFns } from "./AnalitAlternativeMeasurements.vue?vue&type=template&id=2c494b46&scoped=true"
import script from "./AnalitAlternativeMeasurements.vue?vue&type=script&lang=js"
export * from "./AnalitAlternativeMeasurements.vue?vue&type=script&lang=js"
import style0 from "./AnalitAlternativeMeasurements.vue?vue&type=style&index=0&id=2c494b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c494b46",
  null
  
)

export default component.exports